module.exports = __webpack_public_path__ + "media/images/plans/icon-feature-chapel-0ed0d2048d7421031a49f6b8e1828eba.png";